<template id="map-template">
  <div class="homeview-fast-track-entrance">
    <div class="fask-track-entrance-list">
      <div
        class="list-item"
        v-for="item in shortcuts"
        :key="item.Extend1"
        @click="handleClick(item.Extend2)"
      >
        <i class="el-icon-share"></i>
        <span>{{ item.Extend1 }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import MyApis from "../../../apis";

export default {
  name: "NavViewFastTrackEntrance",
  componentName: "NavViewFastTrackEntrance",
  components: {},
  props: {},
  data() {
    return {
      shortcuts: [],
    };
  },
  methods: {
    search() {
      let that = this;
      let searchInfo = {
        SysCode: "NavView",
        Key: "NavUrlList",
      };
      new MyApis.UniformConfigApi()
        .GetConfigItemsListExt(searchInfo)
        .then((r) => {
          r = r.data.Data;
          console.log(r);
          this.shortcuts = r;
        })
        .catch((e) => {
          console.log(e);
          that.$message({
            type: "error",
            message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
          });
        });
    },
    handleClick(url) {
      if (url) {
        if (url.includes("http")) {
          window.open(url);
        } else {
          this.$router.push({
            path: url,
            query: {},
          });

          // eslint-disable-next-line no-undef
          $(".zj-app").removeClass("zj-emergencyoperations-map");
        }
      } else {
        this.$message({
          type: "warning",
          message: "导航入口地址未配置",
        });
      }
    },
  },
  created() {
    this.search();
  },
  mounted() {},
};
</script>
<style scoped>
.homeview-fast-track-entrance {
  padding: 50px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items:flex-start;
  overflow: hidden;
}

.fask-track-entrance-list{
  flex-wrap: wrap !important;
}

.fask-track-entrance-list .list-item {
    height: 25% !important;
    width: 30% !important;
    display: flex;
    flex-direction: column;
    justify-content: center !important;
    align-items: center;
    color: #09eff7 !important;
    font-size:3rem;
    border:1px solid #2AC1FF;
    border-radius: 1rem;
    background-color: rgba(1,1,1,0.3);
}
</style>